import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import TranscriptCourseStatusService from "../../../Services/TranscriptCourseStatus.service";
const makeSearchArgs = {
    loadOptions: (search, options) => TranscriptCourseStatusService.search(Object.assign(Object.assign({}, options), { query: search })).then(({ data }) => data),
    label: "description",
    value: "id",
};
export const TranscriptCourseStatusSearch = makeSearch(makeSearchArgs);
export const TranscriptCourseStatusMultiSearch = makeMultiSearch(makeSearchArgs);
